import config from 'config'

function checkSsoLocation(win) {
	try {
		if (win.closed) {
			return 'closed'
		} else if (win.document.URL.indexOf(config.www + 'sso-successful-login') !== -1) {
			return 'success'
		} else if (win.document.URL.indexOf(config.www) !== -1 && win.document.URL.indexOf('/signup/') === -1) {
			return 'redirect'
		}
		return 'waiting'
	} catch (e) {
		return 'waiting'
	}
}

export default checkSsoLocation
